import React, { lazy } from 'react';
const LearnToDriveWithUs = () => {
  return <section className="py-12 bg-white" data-id="element-177">
      <div className="container mx-auto px-4" data-id="element-178">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-179">
          Learn To Drive With Us
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-180">
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-181">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7mwVa6bd4whWYLDnonxPhc/learner_driver.png" alt="Modern automatic car with dual controls for driving lessons in Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-182" />
            <div className="p-4" data-id="element-183">
              <p className="text-gray-700" data-id="element-184">
                Modern automatic vehicles with dual controls and L plates for
                learner safety
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-185">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6C9xyeasQSxYB3YLkQ23gw/Trsuted_driver.png" alt="Driving instructor teaching pupil in automatic car Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-186" />
            <div className="p-4" data-id="element-187">
              <p className="text-gray-700" data-id="element-188">
                Professional instruction in a comfortable, relaxed learning
                environment
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-189">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wUvF8AjcNPDv3veNxhm1d5/instructor.png" alt="Confident learner driver practicing in Northampton with instructor" className="w-full h-48 object-cover" loading="lazy" data-id="element-190" />
            <div className="p-4" data-id="element-191">
              <p className="text-gray-700" data-id="element-192">
                Build confidence with each lesson as you progress toward test
                readiness
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-193">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3xhxZjwjUY4ZL4apAphEPi/patient_instructor.png" alt="Patient driving instructor providing guidance to student in Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-194" />
            <div className="p-4" data-id="element-195">
              <p className="text-gray-700" data-id="element-196">
                Expert guidance from patient instructors who understand your
                learning needs
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-8" data-id="element-197">
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your driving lessons in Northampton today" data-id="element-198">
            Book Now
          </a>
        </div>
      </div>
    </section>;
};
export default LearnToDriveWithUs;